import { render, staticRenderFns } from "./feedSocialMedia.vue?vue&type=template&id=ec2c02a2&scoped=true"
import script from "./feedSocialMedia.ts?vue&type=script&lang=ts&external"
export * from "./feedSocialMedia.ts?vue&type=script&lang=ts&external"
import style0 from "./feedSocialMedia.vue?vue&type=style&index=0&id=ec2c02a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c02a2",
  null
  
)

export default component.exports